import React, { Component } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  InputAdornment
} from "@material-ui/core";

class EditProjectCost extends Component {
  constructor(props) {
    super();
    this.state = {
      cost: props.cost === null ? 0 : props.cost
    };
  }

  onSubmit = () => {
    const { cost } = this.state;
    const states = { cost: Number(cost), editCost: false };
    this.props.changeState(states);
  }

  render() {
    const { cost } = this.state;
    const { open, onClose } = this.props;
    return (
      <Dialog open={open} style={{ minWidth: "600px" }}>
        <DialogTitle>Editar costo del proyecto</DialogTitle>
        <DialogContent>
          <TextField
            value={cost}
            name="cost"
            type="number"
            fullWidth
            onChange={e => this.setState({ cost: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            color="primary"
            style={{ color: "#009688" }}
          >
            Cancelar
          </Button>
          <Button
            onClick={onClose}
            color="primary"
            style={{ color: "#009688" }}
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default EditProjectCost;
